import { atom } from 'nanostores';

const $undoElem = atom<HTMLElement | null>(null);

function getUndoElem(): HTMLElement {
  const elem = $undoElem.get();
  if (elem) return elem;

  const undoElem = document.createElement('div');
  undoElem.setAttribute('aria-hidden', 'true');
  undoElem.contentEditable = 'plaintext-only';
  undoElem.style.position = 'fixed';
  undoElem.style.top = '-9999px';
  undoElem.style.opacity = '0';
  document.body.appendChild(undoElem);
  $undoElem.set(undoElem);

  undoElem.addEventListener('input', onUndo);
  undoElem.addEventListener('focus', () =>
    setTimeout(() => undoElem.blur(), 0),
  );

  return undoElem;
}

const undoStack: {
  redo: () => void;
  undo: () => void;
}[] = [];

function onUndo(e: InputEvent) {
  const elem = e.target as HTMLDivElement;
  if (elem !== getUndoElem()) return;

  if (!(e.inputType === 'historyUndo' || e.inputType === 'historyRedo')) return;

  const idx = Number(elem.textContent === '' ? '-1' : elem.textContent);

  switch (e.inputType) {
    case 'historyUndo':
      undoStack[idx + 1]?.undo();
      break;
    case 'historyRedo':
      undoStack[idx]?.redo();
      break;
  }
}

export function addUndo(undo: () => void, redo: () => void) {
  const undoElem = getUndoElem();
  undoElem.focus();

  const id = undoStack.length;
  undoStack.push({ redo, undo });

  document.execCommand('selectall');
  document.execCommand('insertText', false, '' + id);

  const sel = window.getSelection();
  if (sel?.containsNode(undoElem, true)) {
    sel.removeAllRanges();
  }
}
